import { makeStyles, colors } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  correct: {
    color: colors.green[500],
  },
  error: {
    color: colors.blueGrey[700],
  },
  errorLight: {
    color: colors.blueGrey[200],
  },
  errorJustSubmitted: {
    color: colors.red[800],
  },
  icon: {
    marginRight: theme.spacing(2),
  },
}))

export default styles
